module.exports = "<div class=\"container\">\r\n    <span>{{'punterBar.logout.confirm' | translate}}</span>\r\n    <div class=\"cancel\">{{'punterBar.logout.cancel' | translate}}</div>\r\n    <div class=\"confirm\" (click)=\"confirm()\">{{'punterBar.logout.ok' | translate}}</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/punter-bar/logout-confirmation/logout-confirmation.component.html
// module id = ../../../../../src/app/punter-bar/logout-confirmation/logout-confirmation.component.html
// module chunks = 1